/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./actions-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var actionsStyles = null;

/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */
var ActionsContainer = function ActionsContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"])
  }, children);
};
export default ActionsContainer;